module.exports = __webpack_public_path__ + "img/avatar-holder.e830f2c.png";